var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5 H65 L48 35 H12.5 Z",
    fill: "#117ACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 12.5 V65 L65 48 V12.5 Z",
    fill: "#117ACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 87.5 H35 L52 65 H87.5 Z",
    fill: "#117ACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 87.5 V35 L35 52 V87.5 Z",
    fill: "#117ACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpmc);
export default __webpack_public_path__ + "static/media/JPMC.c111944bfd19eb5c3aaf3720cde16858.svg";
export { ForwardRef as ReactComponent };